import Api from '@barboxx/api';
import type { Authentication } from '@barboxx/models/types';

import { AuthService, AuthServiceConfigFunctions } from '../providers';
import { createAuthentication } from './authentication';

export interface CustomerAuthenticationConfig
    extends AuthServiceConfigFunctions<Authentication.CustomerAuthReturn> {
    onLogOut?: () => Promise<void>;
}

export function createCustomerAuthentication(
    config: CustomerAuthenticationConfig = {}
) {
    const customerAuthService: AuthService<Authentication.CustomerAuthReturn> =
        {
            login: (data: Authentication.CustomerLoginRequest) =>
                Api.Authentication.Customers.login(data).then(results => {
                    if (results.ok && results.data) {
                        return results.data;
                    } else {
                        throw Error('Login error');
                    }
                }),
            logout: async () => {
                await config?.onLogOut?.();
                return Api.Authentication.Customers.logout().then();
            },
            refreshExpiredToken: query => {
                return Api.Authentication.Customers.refreshExpiredToken(
                    query
                ).then(result => {
                    if (result.ok && result.data) {
                        return result.data;
                    } else {
                        throw Error('Refresh token error');
                    }
                });
            },
            ...config,
        };

    return createAuthentication<Authentication.CustomerAuthReturn>(
        customerAuthService
    );
}
